(function () {
    'use strict';
    $(document).ready(function () {

        var top = $('.top .title-section');
        var topHeight = top.innerHeight();
        var viewportHeight = $(window).height();

        var on_scroll_elements = $('.on-scroll');
        sidebarColors();
        $(document).on('scroll', sidebarColors);

        function sidebarColors() {
            var scrollTop = $(window).scrollTop();

            on_scroll_elements.each(function () {
                var el = $(this);
                var elementTop = el.position().top + el.innerHeight();
                if ($('.homepage').length) {

                } else {
                    if ((scrollTop - topHeight) * -1 < elementTop) {
                        el.addClass('on-white');
                    } else {
                        el.removeClass('on-white');
                    }
                }
            });
        }

        $('.menu-trigger').on('click', function () {
            $(this).find('.hamburger').toggleClass('active');
            $('.logo-container').toggleClass('fixed');
            $('.menu-panel').slideToggle();
        });

        $('.primary-menu >li >ul >li.menu-item-has-children >a').click(function () {
            var $li = $(this).parent();
            var $topLi = $li.parent().parent();
            $topLi.toggleClass('open');
            $li.toggleClass('open');
            $li.find('>ul').slideToggle();
            return false;
        });

        $('.primary-menu >li >ul >li >ul >li.menu-item-has-children >a').click(function () {
            var $li = $(this).parent();
            $li.toggleClass('open');
            $li.find('>ul').slideToggle();
            return false;
        });

        new ModalVideo('.js-modal-btn');

        $('.scroll-animation').on('click', function (e) {
            e.preventDefault();

            var href = $(this).attr('href');

            $("html, body").animate({
                scrollTop: $(href).offset().top
            }, 1000);
        })

    });
}(jQuery));